import React, { HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import { Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import TableCell from '../../../../../../components/TableCell';

const linkToContact = '/dashboard/contact/';

interface ExternalContact {
  id: number;
  name: string;
  lastname: string;
  job?: string;
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  externalContacts: ExternalContact[];
  loading: boolean;
}

const ExternalContactsSection: React.FC<Props> = ({ externalContacts, loading, ...props }) => {
  return (
    <div {...props}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Contact</TableCell>
            <TableCell>Job</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {externalContacts.map((externalContact) => (
            <TableRow key={externalContact.id}>
              <TableCell>
                <Link to={linkToContact + externalContact.id}>
                  <span>{externalContact.name + ' ' + externalContact.lastname}</span>
                </Link>
              </TableCell>

              <TableCell>{externalContact.job ? externalContact.job : 'non-renseigné'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {externalContacts.length == 0 && <span>Aucun contact externe.</span>}
    </div>
  );
};

export default ExternalContactsSection;
